import _implicitStylesheets from "./typeAhead.css";
import _implicitScopedStylesheets from "./typeAhead.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _searchSuggestionOption from "search/suggestionOption";
import _searchRecentItemOption from "search/recentItemOption";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="animated-placeholder-container${0}"${2}><div${"c1"}${2}><span class="placeholder-text${0}"${2}>${"t3"}</span><span class="placeholder-text next${0}"${2}>${"t5"}</span></div></div>`;
const $fragment2 = parseFragment`<div class="action-divider${0}"${2}></div>`;
const $fragment3 = parseFragment`<span class="drawer-category-title${0}"${"a0:data-item"}${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<span class="drawer-category-title${0}"${"a0:data-item"}${2}>${"t1"}</span>`;
const $fragment5 = parseFragment`<span class="drawer-category-title${0}"${"a0:data-item"}${2}>${"t1"}</span>`;
const $fragment6 = parseFragment`<div class="backdrop${0}" data-testid="backdrop"${2}></div>`;
const stc0 = {
  "role": "search"
};
const stc1 = {
  classMap: {
    "input-container": true
  },
  key: 2
};
const stc2 = {
  classMap: {
    "search-icon-container": true
  },
  attrs: {
    "aria-label": "search button"
  },
  key: 3
};
const stc3 = {
  "search-bar-icon": true,
  "magnifier-icon": true
};
const stc4 = {
  "bar-input": true
};
const stc5 = {
  classMap: {
    "action-buttons-container": true
  },
  key: 8
};
const stc6 = {
  "action-button": true
};
const stc7 = {
  "search-bar-icon": true,
  "close-icon": true
};
const stc8 = {
  "action-button": true,
  "send-button": true
};
const stc9 = {
  "search-bar-icon": true,
  "send-icon": true
};
const stc10 = {
  classMap: {
    "action-buttons-container": true
  },
  key: 15
};
const stc11 = {
  "bar-drawer": true
};
const stc12 = {
  "data-testid": "bar-drawer"
};
const stc13 = {
  "list-option": true
};
const stc14 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, b: api_bind, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, gid: api_scoped_id, k: api_key, i: api_iterator, f: api_flatten} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15, _m16, _m17, _m18, _m19, _m20, _m21, _m22, _m23} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.barContainerClass),
    attrs: stc0,
    key: 0,
    on: {
      "focusout": _m0 || ($ctx._m0 = api_bind($cmp.handleContainerFocusOut))
    }
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.glowWrapperClass),
    key: 1
  }, [api_element("div", stc1, [api_element("div", stc2, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc3,
    props: {
      "icon": "search",
      "size": "medium",
      "iconDescription": $cmp.searchBarLabel
    },
    key: 4
  })]), $cmp.showAnimatedPlaceholder ? api_static_fragment($fragment1, 6, [api_static_part(1, {
    className: api_normalize_class_name($cmp.animatedPlaceholderClass)
  }, null), api_static_part(3, null, api_dynamic_text($cmp.currentPlaceholder)), api_static_part(5, null, api_dynamic_text($cmp.nextPlaceholder))]) : null, api_element("input", {
    classMap: stc4,
    attrs: {
      "type": "text",
      "name": "bar-input",
      "placeholder": $cmp.inputPlaceholder,
      "title": $cmp.searchBarLabel,
      "aria-controls": api_scoped_id("search-options"),
      "role": "combobox",
      "aria-autocomplete": "list",
      "aria-activedescendant": "",
      "aria-expanded": $cmp.shouldDisplayDrawer,
      "aria-label": $cmp.searchBarLabel,
      "maxlength": $cmp.maxSearchCharLimit
    },
    props: {
      "value": $cmp.keyword
    },
    key: 7,
    on: {
      "keyup": _m1 || ($ctx._m1 = api_bind($cmp.handleInputKeyUp)),
      "keydown": _m2 || ($ctx._m2 = api_bind($cmp.handleInputKeyDown)),
      "focus": _m3 || ($ctx._m3 = api_bind($cmp.handleInputFocus)),
      "blur": _m4 || ($ctx._m4 = api_bind($cmp.handleInputBlur)),
      "input": _m5 || ($ctx._m5 = api_bind($cmp.handleTextInput))
    }
  }), $cmp.showActionButtons ? api_element("div", stc5, [$cmp.keyword ? api_element("button", {
    classMap: stc6,
    attrs: {
      "type": "button",
      "aria-label": $cmp.labels.clearSearchButton,
      "data-testid": "search-close-icon",
      "tabindex": "0"
    },
    key: 9,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.handleCloseIconClick)),
      "keydown": _m7 || ($ctx._m7 = api_bind($cmp.handleCloseKeyDown))
    }
  }, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc7,
    props: {
      "icon": "close",
      "size": "medium",
      "iconDescription": $cmp.labels.clearSearchButton
    },
    key: 10
  })]) : null, $cmp.showSendButton ? api_static_fragment($fragment2, 12) : null, $cmp.showSendButton ? api_element("button", {
    classMap: stc8,
    attrs: {
      "type": "button",
      "aria-label": $cmp.labels.submitSearchButton,
      "data-testid": "search-send-button"
    },
    key: 13,
    on: {
      "click": _m8 || ($ctx._m8 = api_bind($cmp.handleSendButtonClick)),
      "mousedown": _m9 || ($ctx._m9 = api_bind($cmp.handleSendButtonMouseDown))
    }
  }, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc9,
    props: {
      "icon": "send",
      "size": "medium",
      "iconDescription": $cmp.labels.submitSearchButton
    },
    key: 14
  })]) : null]) : null, !$cmp.showActionButtons ? api_element("div", stc10, [$cmp.keyword ? api_element("div", {
    classMap: stc6,
    attrs: {
      "aria-label": $cmp.labels.clearSearchButton,
      "data-testid": "search-close-icon",
      "tabindex": "0"
    },
    key: 16,
    on: {
      "click": _m10 || ($ctx._m10 = api_bind($cmp.handleCloseIconClick)),
      "keydown": _m11 || ($ctx._m11 = api_bind($cmp.handleCloseKeyDown))
    }
  }, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc7,
    props: {
      "icon": "close",
      "size": "medium",
      "iconDescription": $cmp.labels.clearSearchButton
    },
    key: 17
  })]) : null]) : null])]), api_element("div", {
    classMap: stc11,
    style: $cmp.shouldDisplayDrawerStyle,
    attrs: stc12,
    key: 18
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.drawerContainerClasses),
    attrs: {
      "id": api_scoped_id("search-options"),
      "role": "listbox",
      "aria-label": "Suggestions"
    },
    key: 19
  }, api_flatten([$cmp.shouldShowSearchSuggestions ? api_flatten([!$cmp.isAgenticSearchEnabled ? api_static_fragment($fragment3, 21, [api_static_part(0, {
    attrs: {
      "data-item": $cmp.labels.terms
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.terms))]) : null, !$cmp.isAgenticSearchEnabled ? api_custom_element("search-suggestion-option", _searchSuggestionOption, {
    classMap: stc13,
    attrs: {
      "data-testid": "suggestion-option-component",
      "data-search-value": $cmp.keywordSuggestion.suggestedKeyword,
      "data-type": "termSuggestion"
    },
    props: {
      "suggestion": $cmp.keywordSuggestion,
      "role": "option",
      "id": api_scoped_id($cmp.keywordSuggestion.suggestionId),
      "ariaSelected": "false",
      "tabIndex": "-1"
    },
    key: 22,
    on: {
      "mouseover": _m12 || ($ctx._m12 = api_bind($cmp.handleOptionMouseOver)),
      "click": _m13 || ($ctx._m13 = api_bind($cmp.handleSuggestionClick))
    }
  }) : null, api_iterator($cmp.searchTermSuggestions, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return api_custom_element("search-suggestion-option", _searchSuggestionOption, {
      classMap: stc13,
      attrs: {
        "data-testid": "suggestion-option-component",
        "data-search-value": it.value.suggestedKeyword,
        "data-type": "termSuggestion"
      },
      props: {
        "suggestion": it.value,
        "role": "option",
        "id": api_scoped_id(it.value.suggestionId),
        "ariaSelected": "false",
        "tabIndex": "-1"
      },
      key: api_key(23, it.value.suggestedKeyword),
      on: {
        "mouseover": _m14 || ($ctx._m14 = api_bind($cmp.handleOptionMouseOver)),
        "click": _m15 || ($ctx._m15 = api_bind($cmp.handleSuggestionClick))
      }
    });
  })]) : stc14, $cmp.shouldShowRecentItems ? api_flatten([api_static_fragment($fragment4, 25, [api_static_part(0, {
    attrs: {
      "data-item": $cmp.labels.recentItems
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.recentItems))]), api_iterator($cmp.recentItems, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return api_custom_element("search-recent-item-option", _searchRecentItemOption, {
      classMap: stc13,
      attrs: {
        "data-testid": "recent-item-option-component",
        "data-search-value": it.value.listing.oafId,
        "data-type": "recentItem"
      },
      props: {
        "recentItem": it.value,
        "role": "option",
        "id": api_scoped_id(it.value.recentItemId),
        "tabIndex": "-1"
      },
      key: api_key(26, it.value.listing.oafId),
      on: {
        "mouseover": _m16 || ($ctx._m16 = api_bind($cmp.handleOptionMouseOver)),
        "click": _m17 || ($ctx._m17 = api_bind($cmp.handleRecentItemClick))
      }
    });
  })]) : stc14, $cmp.shouldShowTopSearches ? api_flatten([api_static_fragment($fragment5, 28, [api_static_part(0, {
    attrs: {
      "data-item": $cmp.labels.topSearches
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.topSearches))]), api_iterator($cmp.topSearchesWithIds, function (search) {
    return api_custom_element("search-suggestion-option", _searchSuggestionOption, {
      classMap: stc13,
      attrs: {
        "data-testid": "top-search-option-component",
        "data-search-value": search.suggestedKeyword,
        "data-type": "topSearch"
      },
      props: {
        "suggestion": search,
        "role": "option",
        "id": api_scoped_id(search.suggestionId),
        "ariaSelected": "false",
        "tabIndex": "-1"
      },
      key: api_key(29, search.suggestionId),
      on: {
        "mouseover": _m18 || ($ctx._m18 = api_bind($cmp.handleOptionMouseOver)),
        "click": _m19 || ($ctx._m19 = api_bind($cmp.handleSuggestionClick))
      }
    });
  })]) : stc14]))])]), $cmp.shouldDisplayDrawer ? api_static_fragment($fragment6, 31, [api_static_part(0, {
    on: {
      "click": _m22 || ($ctx._m22 = api_bind($cmp.handleBackdropClick)),
      "mouseover": _m23 || ($ctx._m23 = api_bind($cmp.handleBackdropMouseOver))
    }
  }, null)]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4vp89uu3er4";
tmpl.legacyStylesheetToken = "undefined-_typeAhead";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
